import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import HeaderBase, {
  LogoLink as LogoLinkBase,
  NavLinks,
  NavLink as NavLinkBase,
  PrimaryLink as PrimaryLinkBase,
} from "../headers/light.js";
import {
  Container as ContainerBase,
  ContentWithVerticalPadding,
  Content2Xl,
} from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import logoImageSrc from "images/logo.png";
import serverIllustrationImageSrc from "images/server-illustration-2.svg";
import vid1 from "images/vid1.mp4";
import "../../main.css";
const PrimaryBackgroundContainer = tw.div`-mx-8 px-8 bg-blue-900 text-gray-100`;
const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8`;
const NavLink = tw(
  NavLinkBase
)`lg:text-gray-100 lg:hocus:text-gray-300 lg:hocus:border-gray-100`;
const LogoLink = tw(LogoLinkBase)`text-gray-100 hocus:text-gray-300`;
const PrimaryLink = tw(
  PrimaryLinkBase
)`shadow-raised lg:bg-blue-400 lg:hocus:bg-blue-500`;

const Container = tw(ContainerBase)``;
const Row = tw.div`flex items-center flex-col lg:flex-row`;
const Column = tw.div`lg:w-1/2`;
const TextColumn = tw.div`text-center lg:text-left`;
const IllustrationColumn = tw(Column)`mt-16 lg:mt-0 lg:ml-16`;
const Heading = tw(
  SectionHeading
)`max-w-3xl lg:max-w-4xl lg:text-left leading-tight`;
const Description = tw(
  SectionDescription
)`mt-4 max-w-2xl text-gray-100 lg:text-base mx-auto lg:mx-0`;
const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-8 text-sm sm:text-base px-6 py-5 sm:px-10 sm:py-5 bg-blue-400 inline-block hocus:bg-blue-500`;
const Image = tw.img`w-144 ml-auto`;

export default ({
  heading = "Toronto Web Developers",
  description = "Great Wave Digital specializes in creating custom built websites with modern and optimized designs. From website development, to SEO and marketing, our developers will esure you receive the best quality.",
  primaryButtonText = "Our Projects",
  primaryButtonUrl = "/components/innerPages/ProjectsPage",
  imageSrc = serverIllustrationImageSrc,
}) => {
  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      Great Wave Digital
    </LogoLink>
  );
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/components/innerPages/AboutUsPage">About Us</NavLink>
      <NavLink href="/components/innerPages/ProjectsPage">Projects</NavLink>
      <NavLink href="/components/innerPages/BlogIndexPage">Services</NavLink>
      <PrimaryLink href="/components/innerPages/ContactUsPage">
        Get A Quote
      </PrimaryLink>
    </NavLinks>,
  ];
  return (
    <>
      <Header logoLink={logoLink} links={navLinks} />
      <video src={vid1} autoPlay loop muted></video>
      <div className="content">
        <Heading>{heading}</Heading>
        <Description>{description}</Description>
        <PrimaryButton as="a" href={primaryButtonUrl}>
          {primaryButtonText}
        </PrimaryButton>
      </div>

      <Content2Xl>
        <div className="main">
          {/* <video src={vid1} autoPlay loop muted></video> */}
          {/* <div className="content">
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
          </div> */}
        </div>
        <Container></Container>
      </Content2Xl>
    </>
  );
};
